import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import {
    SET_TEMPLATE_PAGE_DETAILS,
    CLEAR_TEMPLATE_PAGE_DETAILS,
    SEARCH_PARAM,
    SET_MAST_ORDER_TEMPLATE,
    SET_PRODUCT_TO_BE_ADDED,
} from '../action/actionTypes';

const initialState = {
    pageName: '',
    templateName: '',
    accounts: [],
    physicians: [],
    procedures: '',
    itemProducts: [],
    extraItemProducts: [],
    setProducts: [],
    feeProduct: [],
    productDetails: [],
    selectedTemplate: [],
    notes: '',
    isFavorite: false,
    district: '',
    territory: '',
    method: '',
    firstReload: false,
    completePopup: false,
    searchAppliedObject: {},
    isMastOrderTemplate: false,
    productsAdded: [],
    // Ship To, Bill To, Care Of fields for surgery template
    billToId: '',
    billToName: '',
    careOfField: '',
    shipToAddressId: '',
    shipToName: '',
    shipToPartnerId: '',
    templateSubCategoryCode: '',
};
//products: action.payload.products
//? [...action.payload.products]
//: state.cartData.products,

const commonTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_TEMPLATE_PAGE_DETAILS:
            return {
                ...state,
                pageName: action.payload.pageName
                    ? action.payload.pageName
                    : action.payload.pageName == ''
                    ? ''
                    : state.pageName,
                templateName: action.payload.templateName
                    ? action.payload.templateName
                    : action.payload.templateName == ''
                    ? ''
                    : state.templateName,
                accounts: action.payload.accounts
                    ? [...action.payload.accounts]
                    : state.accounts,
                physicians: action.payload.physicians
                    ? [...action.payload.physicians]
                    : state.physicians,
                procedures: action.payload.procedures
                    ? action.payload.procedures
                    : action.payload.procedures == ''
                    ? ''
                    : state.procedures,
                itemProducts: action.payload.itemProducts
                    ? [...action.payload.itemProducts]
                    : state.itemProducts,
                extraItemProducts: action.payload.extraItemProducts
                    ? [...action.payload.extraItemProducts]
                    : state.extraItemProducts,
                setProducts: action.payload.setProducts
                    ? [...action.payload.setProducts]
                    : state.setProducts,
                feeProduct: action.payload.feeProduct
                    ? [...action.payload.feeProduct]
                    : state.feeProduct,
                productDetails: action.payload.productDetails
                    ? [...action.payload.productDetails]
                    : state.productDetails,
                selectedTemplate: action.payload.selectedTemplate
                    ? [...action.payload.selectedTemplate]
                    : state.selectedTemplate,
                notes: action.payload.notes
                    ? action.payload.notes
                    : action.payload.notes == ''
                    ? ''
                    : state.notes,
                district: action.payload.district
                    ? action.payload.district
                    : action.payload.district == ''
                    ? ''
                    : state.district,
                territory: action.payload.territory
                    ? action.payload.territory
                    : action.payload.territory == ''
                    ? ''
                    : state.territory,
                isFavorite: action.payload.isFavorite
                    ? action.payload.isFavorite
                    : null,
                method: action.payload.method
                    ? action.payload.method
                    : action.payload.method == ''
                    ? ''
                    : state.method,
                firstReload: action.payload.firstReload
                    ? action.payload.firstReload
                    : false,
                completePopup: action.payload.completePopup
                    ? action.payload.completePopup
                    : null,
                // Ship To, Bill To, Care Of fields
                billToId: action.payload.billToId
                    ? action.payload.billToId
                    : action.payload.billToId == ''
                    ? ''
                    : state.billToId,
                billToName: action.payload.billToName
                    ? action.payload.billToName
                    : action.payload.billToName == ''
                    ? ''
                    : state.billToName,
                careOfField: action.payload.careOfField
                    ? action.payload.careOfField
                    : action.payload.careOfField == ''
                    ? ''
                    : state.careOfField,
                shipToAddressId: action.payload.shipToAddressId
                    ? action.payload.shipToAddressId
                    : action.payload.shipToAddressId == ''
                    ? ''
                    : state.shipToAddressId,
                shipToName: action.payload.shipToName
                    ? action.payload.shipToName
                    : action.payload.shipToName == ''
                    ? ''
                    : state.shipToName,
                shipToPartnerId: action.payload.shipToPartnerId
                    ? action.payload.shipToPartnerId
                    : action.payload.shipToPartnerId == ''
                    ? ''
                    : state.shipToPartnerId,
                templateSubCategoryCode: action.payload.templateSubCategoryCode
                    ? action.payload.templateSubCategoryCode
                    : action.payload.templateSubCategoryCode === ''
                    ? ''
                    : state.templateSubCategoryCode,
            };

        case CLEAR_TEMPLATE_PAGE_DETAILS: {
            return initialState;
        }
        case SEARCH_PARAM:
            return {
                ...state,
                searchAppliedObject: action.payload.searchAppliedObject
                    ? action.payload.searchAppliedObject
                    : {},
            };
        case SET_MAST_ORDER_TEMPLATE:
            return {
                ...state,
                isMastOrderTemplate: action.payload,
            };
        case SET_PRODUCT_TO_BE_ADDED:
            return {
                ...state,
                productsAdded: action.payload ? action?.payload[0] : state.productsAdded,
            };
        default:
            return {
                ...state,
            };
    }
};

export default persistReducer(
    {
        key: 'templateKey',
        storage: storage,
        whitelist: ['isMastOrderTemplate'],
    },
    commonTemplateReducer
);
